import { YANADOO_CDN_HOST } from 'common/config'

export const BEST_LAST_HOST_CDN = `${YANADOO_CDN_HOST}/promotion/bestAwardsDBOnly_last/`
export const MACBOOKTOGETHER_CDN_HOST = `${YANADOO_CDN_HOST}/promotion/macbookPackage/together`

export const bestAwardsLastValues = {
  metainfo: {
    last: {
      title: '인생 마지막 영어 | 평생수강 0원',
      description: '야나두 하루 10분 영어, 매일 하게 되는 영어 학습',
      site_name: '인생 마지막 영어 | 평생수강 0원',
      imgsrc: `${BEST_LAST_HOST_CDN}og_last.png`
    }
  },
  mainBannerValues: {
    last: {
      backgroundColor: '#f5fecf',
      pc: {
        base: `${BEST_LAST_HOST_CDN}img_main-visual_last.png`,
        webp: `${BEST_LAST_HOST_CDN}img_main-visual_last.webp`
      },
      alt: 'Last 인생 마지막 영어 0원 *최초 1회 구매&미션 달성 시'
    }
  },
  realReview: [
    {
      reviewImgSrc: `${BEST_LAST_HOST_CDN}img_review01.png`,
      reviewImgAlt:
        'AI와 대화하며 연습하니 영어하는 역할에 대한 자신감이 생겼어요. Reviewer 1000만 배우 진선규',
      iframeSrc: 'vXhU6orteaY?si=Umx0EM41sZ2lGIw-'
    },
    {
      reviewImgSrc: `${BEST_LAST_HOST_CDN}img_review02.png`,
      reviewImgAlt:
        '미국에 살면서도 영어공부가 꼭 필요했어요. 현생을 살면서 영어를 잘 할 수 있는 방법을 찾았어요. Reviewer 미국 6년차 유튜버 칙블린님',
      iframeSrc: 'n8UO5xK1Xzo?si=VD714s3trAshnz6R'
    },
    {
      reviewImgSrc: `${BEST_LAST_HOST_CDN}img_review03.png`,
      reviewImgAlt:
        '지속적으로, 밀도있게 많은 문장을 접할 수 있어 정말 효율적인 공부법이에요! Reviewer 연대생 유튜버 예아님',
      iframeSrc: 'Xvvv97ozr1A?si=FIIXvdIY6SEDutXV'
    }
  ],
  scholarship: [
    {
      pc: {
        base: `${BEST_LAST_HOST_CDN}img_scholarship01.png`,
        webp: `${BEST_LAST_HOST_CDN}img_scholarship01.webp`
      },
      alt: 'Challenge'
    },
    {
      pc: {
        base: `${BEST_LAST_HOST_CDN}img_scholarship02.png`,
        webp: `${BEST_LAST_HOST_CDN}img_scholarship02.webp`
      },
      alt: '1일차 도전 시작 새로운 습관을 만들어 보아요, 30일차 한달 째 영어로 말하는 것이 습관이 되어갑니다, 66일차 66일째 영어 말하기 실력과 함께 장학금이 쌓였습니다!'
    },
    {
      pc: {
        base: `${BEST_LAST_HOST_CDN}img_scholarship03.png`,
        webp: `${BEST_LAST_HOST_CDN}img_scholarship03.webp`
      },
      alt: '게임처럼 차곡차곡 쌓이는 재미 덕분에 벌써 전달된 장학금만 무려 88억원'
    }
  ],
  sectionF: {
    curriculum: {
      pc: {
        base: `${MACBOOKTOGETHER_CDN_HOST}/img_mt_solution1.png`,
        webp: `${MACBOOKTOGETHER_CDN_HOST}/img_mt_solution1.webp`
      },
      alt: '커리큘럼'
    },
    aiTlak: {
      character: {
        pc: {
          base: `${BEST_LAST_HOST_CDN}img_solution_ai-talk_char.png`,
          webp: `${BEST_LAST_HOST_CDN}img_solution_ai-talk_char.webp`
        }
      },
      slide: [
        {
          title: (
            <>
              내 상황에 딱 맞는
              <br />
              자유로운 듀얼 학습법
            </>
          ),
          description: (
            <>
              밖에서는 키보드로 집에서는 음성으로
              <br />
              내 장소, 상황에 맞춰 AI 친구와 대화해요
              <br />
              일상 속 영어가 더 가깝게 느껴져요
            </>
          ),
          img: {
            pc: {
              base: `${MACBOOKTOGETHER_CDN_HOST}/img_mt_solution4-1.png`,
              webp: `${MACBOOKTOGETHER_CDN_HOST}/img_mt_solution4-1.webp`
            }
          }
        },
        {
          title: (
            <>
              실시간 번역으로
              <br />
              독해력 UP
            </>
          ),
          description: (
            <>
              모르는 문장이 있어도 괜찮아요
              <br />
              말풍선의 ‘번역’ 버튼을 누르면
              <br />
              단어, 문장 뜻 모두 확인할 수 있어요
            </>
          ),
          img: {
            pc: {
              base: `${MACBOOKTOGETHER_CDN_HOST}/img_mt_solution4-2.png`,
              webp: `${MACBOOKTOGETHER_CDN_HOST}/img_mt_solution4-2.webp`
            },
            mo: {
              base: `${MACBOOKTOGETHER_CDN_HOST}/img_m_mt_solution4-2.png`,
              webp: `${MACBOOKTOGETHER_CDN_HOST}/img_m_mt_solution4-2.webp`
            }
          }
        },
        {
          title: (
            <>
              1:1 맞춤 피드백으로
              <br />
              빠른 교정
            </>
          ),
          description: (
            <>
              더 나은 표현으로 말할 수 있도록
              <br />
              바로 맞는 문장으로 교정해드려요
            </>
          ),
          noti: '*해당 기능은 신규 캐릭터인 Tom, Jenny에 한해서만 제공됩니다',
          img: {
            pc: {
              base: `${MACBOOKTOGETHER_CDN_HOST}/img_mt_solution4-3.png`,
              webp: `${MACBOOKTOGETHER_CDN_HOST}/img_mt_solution4-3.webp`
            },
            mo: {
              base: `${MACBOOKTOGETHER_CDN_HOST}/img_m_mt_solution4-3.png`,
              webp: `${MACBOOKTOGETHER_CDN_HOST}/img_m_mt_solution4-3.webp`
            }
          }
        },
        {
          title: (
            <>
              AI 음성 기능으로
              <br />
              발음 확인까지
            </>
          ),
          description: (
            <>
              AI 원어민 친구가
              <br />
              모범 발음까지 알려주니까
              <br />
              올바른 발음까지 완벽하게 짚고가요
            </>
          ),
          img: {
            pc: {
              base: `${MACBOOKTOGETHER_CDN_HOST}/img_mt_solution4-4.png`,
              webp: `${MACBOOKTOGETHER_CDN_HOST}/img_mt_solution4-4.webp`
            },
            mo: {
              base: `${MACBOOKTOGETHER_CDN_HOST}/img_m_mt_solution4-4.png`,
              webp: `${MACBOOKTOGETHER_CDN_HOST}/img_m_mt_solution4-4.webp`
            }
          }
        }
      ]
    },
    aiNadoo: [
      {
        pc: {
          base: `${BEST_LAST_HOST_CDN}img_solution_ai-nadoo01.png`,
          webp: `${BEST_LAST_HOST_CDN}img_solution_ai-nadoo01.webp`
        },
        alt: '이해를 돕는 예시 문장도 무제한으로 생성!'
      },
      {
        pc: {
          base: `${BEST_LAST_HOST_CDN}img_solution_ai-nadoo02.png`,
          webp: `${BEST_LAST_HOST_CDN}img_solution_ai-nadoo02.webp`
        },
        alt: '어려운 문법이 있다면 이해될 때까지 자세하게!'
      },
      {
        pc: {
          base: `${BEST_LAST_HOST_CDN}img_solution_ai-nadoo03.png`,
          webp: `${BEST_LAST_HOST_CDN}img_solution_ai-nadoo03.webp`
        },
        alt: '바쁜 수강생을 위해 중요한 답변만 쏙쏙 요약해드려요'
      },
      {
        pc: {
          base: `${BEST_LAST_HOST_CDN}img_solution_ai-nadoo04.png`,
          webp: `${BEST_LAST_HOST_CDN}img_solution_ai-nadoo04.webp`
        },
        alt: '오타도 걱정마세요! AI 나두는 다 알아들어요'
      },
      {
        pc: {
          base: `${BEST_LAST_HOST_CDN}img_solution_ai-nadoo05.png`,
          webp: `${BEST_LAST_HOST_CDN}img_solution_ai-nadoo05.webp`
        },
        alt: '영어와 관련됐다면 어떤 질문이든 답해드려요!'
      }
    ]
  }
}
